import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import WalterLoader from '../components/shared/WalterLoader';
import { useAuth } from './AuthContext';
import { apiSetPassword, apiTokenInfo } from './authApi';
import AuthCard from './AuthCard';
import PasswordFields, { passwordError } from './PasswordFields';
import '../styles/Auth.css';

// Pages /invitation/:token et /reset/:token : lien à usage unique généré par un admin
// (page Comptes). Le mot de passe choisi ouvre directement une session.
export default function SetPasswordPage({ purpose }) {
    const { token } = useParams();
    const navigate = useNavigate();
    const { acceptSession } = useAuth();
    const [info, setInfo] = useState(null);
    const [loadError, setLoadError] = useState(null);
    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        apiTokenInfo(token)
            .then((data) => {
                if (data.purpose !== purpose) throw new Error("Ce lien n'est plus valide.");
                setInfo(data);
            })
            .catch((err) => setLoadError(err.message));
    }, [token, purpose]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const invalid = passwordError(password, confirmation);
        if (invalid) {
            setError(invalid);
            return;
        }
        setError(null);
        setSubmitting(true);
        try {
            await acceptSession(await apiSetPassword(purpose, token, password));
            navigate('/', { replace: true });
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    const title = purpose === 'invite' ? 'Bienvenue sur Walter' : 'Nouveau mot de passe';

    if (loadError) {
        return (
            <AuthCard title={title}>
                <div className="auth-error" role="alert">{loadError}</div>
                <Link className="auth-link" to="/mot-de-passe-oublie">Recevoir un nouveau lien</Link>
                <Link className="auth-link" to="/login">Aller à la page de connexion</Link>
            </AuthCard>
        );
    }
    if (!info) {
        return (
            <div className="auth-page">
                <WalterLoader />
            </div>
        );
    }

    return (
        <AuthCard
            title={title}
            subtitle={purpose === 'invite'
                ? `${info.name}, choisissez le mot de passe de votre compte ${info.email}.`
                : `Choisissez un nouveau mot de passe pour ${info.email}. Vos autres sessions seront fermées.`}
        >
            <form className="auth-form" onSubmit={handleSubmit}>
                <input type="email" autoComplete="username" value={info.email} readOnly hidden />
                <PasswordFields
                    password={password} confirmation={confirmation}
                    onPasswordChange={setPassword} onConfirmationChange={setConfirmation}
                />
                {error && <div className="auth-error" role="alert">{error}</div>}
                <button type="submit" className="auth-btn auth-btn--primary" disabled={submitting}>
                    {submitting ? 'Enregistrement…' : 'Enregistrer et se connecter'}
                </button>
            </form>
        </AuthCard>
    );
}
